module.exports = __webpack_public_path__ + "img/vlag-de.35d51e654bda65fd131d5267aea2d664.svg";